module.exports = __webpack_public_path__ + "img/tabs1-1.e4ec4fef.png";